import { Box, Button, Flex } from '@chakra-ui/react'
import { useCallback, useState } from 'react'

import logger from '@/utils/logger'

import useInterval from '@/client/hooks/useInterval'
import isUpdateAvailable from '@/client/services/update/isUpdateAvailable'
import isUpdateLocked from '@/client/services/update/isUpdateLocked'

import { useToaster } from '@/components/Toast/useToaster'

// Keep a non-component, global flag for this, because we dont
// want to reprompt for update on a navigation event.
let hasPresentedUpdate = false

export default function WebsiteUpdateToast() {
  const toast = useToaster()
  const [hasUpdateAvailable, setHasUpdateAvailable] = useState(false)

  const tryPresentingUpdate = useCallback(() => {
    if (hasPresentedUpdate || isUpdateLocked()) {
      return
    }
    hasPresentedUpdate = true

    toast({
      description: (
        <Flex direction="row">
          <Box>
            A new version of Schoolhouse is available. Reload to update. Unsaved changes will be
            lost.
          </Box>
          <Flex justifyContent="center" alignItems="center" mx="8px">
            <Button onClick={() => globalThis.location.reload()}>Reload</Button>
          </Flex>
        </Flex>
      ),
      status: 'info',
      duration: null,
    })
  }, [toast])

  useInterval(
    () => {
      if (hasUpdateAvailable) {
        // Tick the callback to attempt to render the toast
        // maybe isUpdateLocked() has a different value now
        tryPresentingUpdate()
        return
      }

      isUpdateAvailable().then(
        updateAvailable => {
          if (updateAvailable) {
            setHasUpdateAvailable(true)
            tryPresentingUpdate()
          }
        },
        err => {
          logger.error('Error checking for application update', {
            err,
          })
        }
      )
    },
    30 * 1000,
    [hasUpdateAvailable]
  )

  return null
}
